export default "/images/vendor/flag-icon-css/flags/4x3/gs.svg?70cddc03fbf97161a7da781b8e34775a";